export default (obj) => {
  if (typeof obj !== 'object') {
    return [];
  }

  return Object.keys(obj)?.reduce(
    (acc, key) => [...acc, { value: key, text: obj[key] }],
    []
  );
};
